/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Ujjwal Singh >

*/
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { connect } from "react-redux";

import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Avatar, Typography } from "@material-ui/core";

//theme
import palette from "theme/palette";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "fit-content",
  },
  avatar: {
    width: 60,
    height: 60,
    border: `2px solid ${theme.palette.action.active}`,
    backgroundColor: "transparent",
    color: palette.white,
  },
  miniAvatar: {
    width: 30,
    height: 30,
    border: `2px solid ${theme.palette.action.active}`,
    backgroundColor: "transparent",
    color: palette.white,
  },
  typographyName: {
    marginTop: theme.spacing(1),
    color: theme.palette.black,
  },
  typographyOrgName: {
    color: theme.palette.black,
  },
}));

const Profile = (props) => {
  const { className, ...rest } = props;

  const {
    fname = "",
    mname = "",
    lname = "",
    job_title = "",
    email = "",
    orgz_name = "",
    profile = "",
    prof_img = "",
    prim_role = "",
    prim_specialization = "",
    scnd_role = "",
    scnd_specialization = "",
  } = props?.userStore?.userProfile ? props?.userStore?.userProfile : "";

  const classes = useStyles();
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Avatar
        alt="Person"
        className={!props.sidebarMini ? classes.avatar : classes.miniAvatar}
        src={
          prof_img !== undefined && prof_img !== null
            ? typeof prof_img !== "string"
              ? Buffer.from(prof_img.data).toString("utf-8")
              : prof_img
            : ""
        }
        // Disabled profile/account page at request of Ms.Amruta.
        // to="/account"
        // component={RouterLink}
      />
      {!props.sidebarMini ? (
        <Typography className={classes.typographyName} variant="h6">
          {fname !== undefined ? fname : ""} {mname !== undefined ? mname : ""}{" "}
          {lname !== undefined ? lname : ""}
        </Typography>
      ) : (
        ""
      )}
      {!props.sidebarMini ? (
        <Typography variant="body2" className={classes.typographyOrgName}>
          {orgz_name}
        </Typography>
      ) : (
        ""
      )}
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string,
};
function mapStateToProps(store) {
  return {
    globalStore: store.globalStore,
    patientStore: store.patientStore,
    userStore: store.userStore,
  };
}
export default connect(mapStateToProps, {})(Profile);
